import React, { createContext } from 'react';

const AudioContext = createContext({});

export { AudioContext };
